import { useState, useEffect } from 'react';
import { Campaign, GameResult } from '../../types';
import { storage } from './storage';

type LastGameResult = {
  gameResult: GameResult;
  timestamp: number;
};

export const saveLastGameResult = (campaignId: number, gameResult?: GameResult) => {
  if (!gameResult) {
    return;
  }

  const lastGameResult: LastGameResult = {
    timestamp: Date.now(),
    gameResult,
  };

  storage.setItem(`eg-last-game-result-${campaignId}`, JSON.stringify(lastGameResult));
};

export const getLastGameResult = (campaignId?: number): LastGameResult | undefined => {
  if (!campaignId) {
    return;
  }

  const lastGameResult = storage.getItem(`eg-last-game-result-${campaignId}`);

  if (!lastGameResult) {
    return;
  }

  try {
    return JSON.parse(lastGameResult);
  } catch (err) {
    return undefined;
  }
};

export const isCampaignAvailable = (campaign?: Campaign): boolean => {
  if (!campaign) {
    return false;
  }

  const lastGameResult = getLastGameResult(campaign.id);

  if (lastGameResult) {
    const timePassed = Date.now() - lastGameResult.timestamp;
    const widgetBreakDuration = campaign.widgetBreakDuration * 60 * 60 * 1000;

    if (timePassed <= widgetBreakDuration) {
      return false;
    }
  }

  return true;
};

export const useCampaignAvailable = (campaign?: Campaign): [boolean, (available: boolean) => void] => {
  const [available, setAvailable] = useState(true);

  useEffect(() => {
    setAvailable(isCampaignAvailable(campaign));
  }, [campaign]);

  return [available, setAvailable];
};
